import {NewTableDef, TableColumnDef} from 'app/shared/tables/table-column-def';

export interface StoreQueryResultEntry {
    storeId: number;
    storeName: string;
    regionName: string;
    address: string;
    owner?: any;
    city: string;
}

export interface StoreCreateCommand {
    Name: string;
    ZipCode: string;
    City: string;
    Region0: string;
    Chain: string;
    Street: string;
    StreetNumber: number;
    Code: string;
    Number: string;
    Nip: string;
    Region1: string;
    Country: string;
    Surface: number;
    CheckboxNb: number;
    StockType: string;
    FridgeBeer: boolean;
    FridgeIceCream: boolean;
}

export interface StoreUpdateCommand {
    Id: number;
    Name: string;
    ZipCode: string;
    City: string;
    Region0: string;
    Chain: string;
    Street: string;
    StreetNumber: number;
    Code: string;
    Number: string;
    Nip: string;
    Region1: string;
    Country: string;
    Surface: number;
    CheckboxNb: number;
    StockType: string;
    FridgeBeer: string;
    FridgeIceCream: string;
}

export interface AssignCompetitorShopCommand {
    storeId: number;
    compStoreIds: number[];
}

export interface UpdateStoreCommand {
    StoreId: number;
    StoreName: string;
    RegionName: string;
    Address: string;
    Owner?: any;
    City: string;
}

export class CreateStore {
    storeName: string = '';
    regionName: string = '';
    address: string = '';
    owner?: string = '';
    lat: number = 52.237049;
    lng: number = 21.017532;
}

export interface Store {
    storeId: number;
    storeName: string;
    regionName: string;
    address: string;
    owner?: any;
    city: string;
    location?: StoreLocation;
}

export interface StoreLocation {
    lat: number;
    lng: number;
}

export class CompStoreDescriptionQuery {
    CompStoreId: number;
    CompStoreAddress: string;
    CompStoreName: string;
    CompStoreZipCode: string;
    CompStoreCity: string;
    CompStoreRegion0: string;
    CompStoreRegion1: string;
    CompStoreCountry: string;
    CompStoreChain: string;
    CompStoreSurface: string;
    CompStoreCheckboxNb: string;
    CompStoreStockType: string;
    CompStoreFridgeBeer: string;
    CompStoreFridgeIceCream: string;
    CompStoreStreet: string;
    CompStoreStreetNumber: string;

    public static getColumnNames(): string[] {
        return [
            'StoreName',
            'StoreRegion0',
            'StoreRegion1',
            'StoreCity',
            'StoreZipCode',
            'StoreStreet',
            'StoreStreetNumber',
        ];
    }
}

export class CompStoreIDsListQuery {
    CompetitorStoreId: number;
}

export class StoreCompetitorExpanded {
    CompetitorStore: StoreListQuery;
    CompetitorStoreId: number;
    StoreId: number;
}

export class StoreListQuery {
    Id: number;
    Address: string;
    Name: string;
    Chain: string;
    ZipCode: string;
    Code: string;
    City: string;
    Region0: string;
    Region1: string;
    Country: string;
    Surface: number;
    CheckboxNb: number;
    StockType: string;
    FridgeBeer: string;
    FridgeIceCream: string;
    Street: string;
    StreetNumber: string;
    AddressWithNR: string;
    Number: number;
    Nip: number;
    Rodzaj: string;
    ClusterId: number | null;
    FloorPlanFileId: string | null;

    constructor(Id: number) {
        this.Id = Id;
    }

    public static getColumnInfo(): NewTableDef {
        return {
            tableId: 'StoreListQuery',
            columns: [
                { columnDef: 'Id'},
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa placówki',
                    isGeneralSearchColumn: true,
                    width: 30,
                },
                {
                    field: 'Region0',
                    columnDef: 'Region0',
                    header: 'Województwo',
                    filterValue: 'StoreRegions',
                    width: 20,
                },
                {
                    field: 'City',
                    columnDef: 'City',
                    header: 'Miasto',
                    width: 25,
                },
                {field: 'AddressWithNR', columnDef: 'AddressWithNR', header: 'Adres', width: 25},
            ]
        };
    }
}

export class StoreListQueryModel {
    Id: number;
    Name: string;
    ZipCode: string;
    City: string;
    Region0: string;
    Region1: string;
    AddressWithNR: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'StoreListQueryModel',
            columns: [
                {columnDef: 'Id'},
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa placówki',
                    isGeneralSearchColumn: true,
                    width: 25,
                },
                {
                    field: 'Region0',
                    columnDef: 'Region0',
                    header: 'Województwo',
                    filterValue: 'StoreRegions',
                    width: 17,
                },
                {
                    field: 'Region1',
                    columnDef: 'Region1',
                    header: 'Region',
                    width: 14
                },
                {
                    field: 'City',
                    columnDef: 'City',
                    header: 'Miasto',
                    width: 14,
                },
                {
                    field: 'ZipCode',
                    columnDef: 'ZipCode',
                    header: 'kod pocztowy',
                    width: 14.0833
                },
                {
                    field: 'AddressWithNR',
                    columnDef: 'AddressWithNR',
                    header: 'Adres',
                    width: 25
                },
                {
                    field: 'Cluster',
                    columnDef: 'Cluster',
                    header: 'Klaster',
                    width: 10,
                    showSearch: false,
                },
            ]
        };
    }
}

export class CompetitorShopListForOwnShopQuery {
    AddressWithNR: string;
    City: string;
    Id: number;
    Name: string;
    Region0: string;
    Region1: string;
    ZipCode: string;

    public static tableInfo(): Array<TableColumnDef> {
        return [
            {columnDef: 'Id'},
            {
                field: 'Name',
                columnDef: 'Name',
                header: 'Nazwa placówki',
                isGeneralSearchColumn: true,
                width: 25,
            },
            {
                field: 'Region0',
                columnDef: 'Region0',
                header: 'Województwo',
                filterValue: 'StoreRegions',
                width: 25,
            },
            {
                field: 'City',
                columnDef: 'City',
                header: 'Miasto',
                width: 25,
            },
            {field: 'AddressWithNR', columnDef: 'AddressWithNR', header: 'Adres', width: 25},
        ];
    }
}

export class ShelfModel {
    Id: string;
    Name: string;
    Meters: number;

    constructor(Id: string, Name: string, Meters: number) {
        this.Id = Id;
        this.Name = Name;
        this.Meters = Meters;
    }

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'ShelfList',
            columns: [
                {field: 'Id', columnDef: 'Id'},
                {field: 'Name', columnDef: 'Name', header: 'Nazwa', width: 15, isGeneralSearchColumn: true},
                {field: 'Meters', columnDef: 'Meters', header: 'Metraż', width: 10, showSort: false, showSearch: false}
            ]
        };
    }
}

export class ClusterShelfModel {
    Id: number;
    Count: number;
    Shelf: ShelfModel;

    constructor(Id: number, Count: number, Shelf: ShelfModel) {
        this.Id = Id;
        this.Count = Count;
        this.Shelf = Shelf;
    }
}

export class CategoryShelfModel {
    Category: string;
    CategoryId: number;
    FirstShelf: ClusterShelfModel;
    SecondShelf: ClusterShelfModel;
    ThirdShelf: ClusterShelfModel;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CategoryShelfList',
            columns: [
                {field: 'Id', columnDef: 'Id'},
                {field: 'Category', columnDef: 'Category', header: 'Kategoria', width: 15, isGeneralSearchColumn: true, showSort: false},
                {field: 'FirstShelf', columnDef: 'shelf', header: 'Pierwszy regał', width: 10, showSort: false, showSearch: false},
                {field: 'SecondShelf', columnDef: 'shelf', header: 'Drugi regał', width: 10, showSort: false, showSearch: false},
                {field: 'ThirdShelf', columnDef: 'shelf', header: 'Trzeci regał', width: 10, showSort: false, showSearch: false},
                {field: 'Meters', columnDef: 'Meters', header: 'Metry bieżące', width: 5, showSort: false, showSearch: false},
            ]
        };
    }
}
